import { CardComponentProps } from "@~/types/types";
import styles from "./SponsorMessage.module.scss";

export function SponsorMessage({
  product,
}: Pick<CardComponentProps, "product">) {
  const { advertising } = product;

  if (!advertising) return null;

  return (
    <span
      aria-label={"Sponsored product"}
      className={styles.sponsored_text}
      data-testid="sponsored-product-tag"
    >
      Sponsored
    </span>
  );
}
